import { Action } from "@ngrx/store";

export const CACHED_ACTION_SUFFIX = "[Cached]";
export const CACHED_SUCCESS_ACTION_SUFFIX = "[Cached Success]";
export const SUCCESS_SUFFIX = " Success";

/**
 * key: cache key
 */
export type StateCacheState = Record<string, FetchedInfo>;

export interface FetchedInfo {
	timestamp: number;
	onServer: boolean;
}

export interface StateCacheOptions {
	cacheStrategy: StateCacheStrategy;
	/**
	 * used with {@link StateCacheStrategy.Expiry}
	 */
	expirationMs?: number;
	/**
	 * will be dispatched when cache is hit and fetch action is not dispatched
	 */
	fallbackAction?: Action;

	cacheKey: string;
}

export interface CacheDetail extends StateCacheOptions {
	originalType: string;
}

export interface CacheType {
	cacheDetail: CacheDetail;
}

/**
 * @deprecated should not be used other than for deprecated `createCachedGetAction`
 */
export interface GetActionCached extends StateCacheOptions, Action {
	/**
	 * original "fetch" action that will be dispatched if cache is not hit
	 */
	fetchAction: any;
}

export const enum StateCacheStrategy {
	/**
	 * Will dispatch once and cache until cleared manually
	 */
	Indefinite,
	/**
	 * Will cache dispatches made on server, first dispatch on client will be skipped, e.g.:
	 * [server] get (dispatched, cached)
	 * [client] get (not dispatched)
	 * [client] get (dispatched)
	 *
	 * Does not affect actions dispatched on client only
	 */
	Server,
	/**
	 * Simple time based expiration:
	 * 00:00 get (dispatched, cached, e.g. 2min)
	 * 00:01 get (not dispatched)
	 * 00:02 get (not dispatched)
	 * 00:03 get (dispatched, cached again)
	 *
	 * Works like thottling - max one dispatch per specified time
	 */
	Expiry,
}

export interface SuccessActionPayload {
	cacheKey: string;
	successAction: Action;
}

export interface SuccessActionCache extends Action {
	cacheKey: string;
	isCachedSuccess: boolean;
}

export interface SetFetchedActionPayload {
	cacheKey: string;
	isServer: boolean;
}
